import { useTranslation } from "react-i18next";

import SeverityGridForm from "@/features/AssetTypes/SeverityGrids/SeverityGridForm";
import { useCreate } from "@/hooks/queries";

const Create = ({ model, assetTypeId }) => {
  const { t } = useTranslation();

  const mutation = useCreate("severityGrids", { rootId: assetTypeId });
  const initialValues = {
    name: model?.name,
    description: model?.description,
    severity_tree_translation: JSON.stringify(
      model?.severity_tree_translation,
      null,
      2
    ),
  };

  return (
    <SeverityGridForm
      mutation={mutation}
      saveButtonLabel={t("global:add")}
      initialValues={initialValues}
    />
  );
};

export default Create;
